import { render, staticRenderFns } from "./CreateCardModal.vue?vue&type=template&id=792c653c&scoped=true&"
import script from "./CreateCardModal.vue?vue&type=script&lang=js&"
export * from "./CreateCardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792c653c",
  null
  
)

export default component.exports